import React, { useCallback, useMemo } from 'react';
import propTypes from 'prop-types';
import { MyTag } from '@laigu/component';

import { allVersionConfig } from '@laigu/utils';
import style from './index.less';

function EnterpriseItem({
  plan = -1,
  name = '',
  seat = 0,
  account = 0,
  selected = false,
  onSelected = () => null,
  value = '',
  isTest = false
}) {

  const { color, planName } = useMemo(() => {
    let color = 'tag-gray';
    if ([2, 3, 5, 1003].includes(plan)) {
      color = 'tag-seagreen';
    } else if ([4, 8, 1004].includes(plan)) {
      color = 'tag-navyblue';
    } else if ([6, 7].includes(plan)) {
      color = 'tag-orchid';
    }
    const nameObj = allVersionConfig.find(version => version.value === plan);
    let name = '暂无版本';
    if (nameObj && !isTest) {
      name = nameObj.text;
    }
    if (isTest) {
      name = '试用版';
      color = 'tag-gray';
    }
    return {
      planName: name,
      color
    };
  }, [plan, isTest]);

  const onItemClick = useCallback(() => {
    onSelected(value);
  }, [value, onSelected]);

  return (
    <div onClick={onItemClick} className={`${style.item} ${selected ? style.selected : ''}`}>
      <div className={style.name}>{name}</div>
      <div className={style.tag_list}>
        <MyTag color={color}>{planName}</MyTag>
        <MyTag color="tag-sienna">{seat}坐席</MyTag>
        <MyTag color="tag-blue">{account}账号</MyTag>
      </div>
    </div>
  );
}

EnterpriseItem.propTypes = {
  plan: propTypes.number,
  name: propTypes.string,
  seat: propTypes.number,
  account: propTypes.number,
  selected: propTypes.bool,
  onSelected: propTypes.func,
  value: propTypes.any,
  isTest: propTypes.bool
};

export default EnterpriseItem;
